<template>
  <div class="body">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishedText"
      :immediate-check="false"
      @load="loadMore"
    >
      <van-cell v-for="episode in episodes" :key="episode.id">
        <van-skeleton
          avatar
          avatar-shape="square"
          avatar-size="100"
          :row="3"
          :loading="skeletonLoading"
        >
          <EpisodeCardNew
            :showRating="false"
            :showPubtime="false"
            :episode="episode"
            :voucher-id="voucherId"
            @voucher-update-success="voucherUpdateSuccess"
          />
        </van-skeleton>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import EpisodeCardNew from './episode-card-new.vue'
  import Vue from 'vue'
  import { List } from 'vant'
  import { Cell, CellGroup } from 'vant'
  import { Tag } from 'vant'
  import { Skeleton } from 'vant'
  Vue.use(List)
  Vue.use(Cell).use(CellGroup)
  Vue.use(Tag)
  Vue.use(Skeleton)

  export default {
    name: 'episode-list',
    components: {
      EpisodeCardNew
    },
    props: {
      slug: {
        type: String,
        default: ''
      },
      categoryId: {
        type: Number,
        default: null
      },
      episodeIds: {
        type: Array,
        default: function () {
          return []
        }
      },
      editorChoiceOnly: {
        type: Boolean,
        default: false
      },
      publicOnly: {
        type: Boolean,
        default: false
      },
      premiumOnly: {
        type: Boolean,
        default: false
      },
      sale: {
        type: Boolean,
        default: false
      },
      playHistory: {
        type: Boolean,
        default: false
      },
      purchaseList: {
        type: Boolean,
        default: false
      },
      limit: {
        type: Number,
        default: 0
      },
      showNoMoreHint: {
        type: Boolean,
        default: true
      },
      voucherId: {
        type: Number,
        default: null
      },
      searchKeyword: {
        type: String,
        default: ''
      }
    },
    watch: {
      // slug (newVal, oldVal) {
      //   if (newVal && newVal != oldVal) {
      //     this.loadData()
      //   }
      // },
      slug: {
        handler: function (slug) {
          if (slug.length > 0) {
            this.loadData()
          }
        },
        immediate: true
      },
      episodeIds: {
        handler: function (episodeIds) {
          window.console.log('episodeIds', episodeIds)
          if (episodeIds.length > 0) {
            this.getEpisodes()
          }
        },
        immediate: true
      },
      showNoMoreHint: {
        handler: function (showNoMoreHint) {
          if (showNoMoreHint == false) {
            this.finishedText = ''
          }
        },
        immediate: true
      }
    },
    data () {
      return {
        skeletonLoading: true,
        loading: false,
        finished: false,
        finishedText: '没有更多了',
        episodes: [],
        next: '',
      }
    },
    methods: {
      loadData () {
        // window.console.log("EpisodeList组件建立...")
        // window.console.log(document.documentElement.scrollTop)
        let count
        if (this.limit > 0) {
          this.finished = true
          this.finishedText = ''
          count = this.limit
        } else { count = 10 }
        for (var i = 0; i < count; i++) {
          this.episodes.push({})
        }
        this.getEpisodes()
      },
      getEpisodes () {
        // window.console.log("EpisodeList组件获取Episodes...")  
        let that = this
        let params = { slug: that.slug }
        if (that.playHistory || that.purchaseList) {
          if (that.playHistory) {
            // 获取播放记录
            that.$api.history.episode_list(params).then(res => {
              that.next = res.data.next
              that.loading = false
              that.skeletonLoading = false
              if (res.data.next == null) {
                that.finished = true
              }
              if (that.limit > 0) {
                that.episodes = res.data.results.slice(0, that.limit)
              } else {
                that.episodes = res.data.results
              }
              return
            })
          }
          if (that.purchaseList) {
            // 获取购买记录
            that.$api.order.episode_list(params).then(res => {
              that.next = res.data.next
              that.loading = false
              that.skeletonLoading = false
              if (res.data.next == null) {
                that.finished = true
              }
              if (that.limit > 0) {
                that.episodes = res.data.results.slice(0, that.limit)
              } else {
                that.episodes = res.data.results
              }
              return
            })
          }
        } else {
          if (that.editorChoiceOnly) {
            params.editorchoice = true
          }
          if (that.publicOnly) {
            params.public = true
          }
          if (that.premiumOnly) {
            params.premium = true
          }
          if (that.sale) {
            params.sale = true
          }
          if (that.categoryId) {
            params.category_id = that.categoryId
          }
          if (that.episodeIds.length > 0) {
            params.episode_ids = JSON.stringify(
              that.episodeIds
            )
          }
          if (that.searchKeyword) {
            params.keyword = that.searchKeyword
          }
          that.$api.episode.list(params).then(res => {
            window.console.log("params:", params)
            window.console.log("获取到的Episodes:")
            window.console.log(res)
            that.$emit("got-episodes-count", res.data.count)
            that.next = res.data.next
            if (res.data.next == null) {
              that.finished = true
            }
            if (that.limit > 0) {
              that.episodes = res.data.results.slice(0, that.limit)
            } else {
              that.episodes = res.data.results
            }
            that.skeletonLoading = false
            that.loading = false
          })
        }
      },
      loadMore () {
        // window.console.log("载入更多...")
        // window.console.log(this.next)
        let that = this
        if (that.next) {
          that.loading = true
          let url = that.next.split('/api/')[1] // 截掉前面的域名和 /api/ 部分
          that.$api.normal.load(url).then(res => {
            that.episodes = that.episodes.concat(res.data.results)
            that.next = res.data.next
            that.loading = false
            if (that.next == null) {
              that.finished = true
            }
          })
        } else {
          if (that.next === null) {
            that.finished = true
          }
        }
      },
      voucherUpdateSuccess: function () {
        // window.console.log("收到 Voucher 更新成功事件通知2")
        this.$emit('voucher-update-success')
      }
    },
    created () {
    },
    mounted () {
      window.console.log("EPISODE_LIST被加载")
    },
    activated () {
      // window.console.log('About has been activated')
      // this.loadData()
    },
    deactivated () {
      // window.console.log('About has been deactivated')
    }
  }
</script>

<style lang="css" scoped>
  .body {
    background: #fff;
  }
</style>
